export default __webpack_public_path__ + "static/media/(21).705a2f08.jpeg";